var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanHairstyle4C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type3_x5F_hairstyles:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M405.9,78.5c-2.3-0.7-4.9-1.2-7.7-1.8c-4.4-0.8-9.3-1.5-14.5-2.1c-1-0.1-1.9-0.2-2.9-0.3 c-9.4-0.8-19.6-1.1-29-0.7c-0.8,0-1.6,0.1-2.5,0.1c-5.9,0.3-11.5,1-16.5,1.9c-0.4,0.1-0.9,0.2-1.3,0.2c-1.2,0.2-2.4,0.5-3.7,0.7 c-10.3,2.1-20.6,5-29.5,10.4c-0.6,0.3-1.1,0.7-1.7,1.1c-2.9,2-5.9,4-8.2,6.4c39.1-21,87.8-22.3,129-7.6 C415.3,82.4,411.5,80.1,405.9,78.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7A5D34",
    d: "M285.2,107.4c1.1,3.3,3.4,6.1,6.1,7.9c6.4-3.7,13.1-6.8,19.9-9.2c6.8-2.4,13.8-4.3,20.9-5.6 c5.4-1,10.8-1.7,16.2-2c5.5-0.4,10.9-0.4,16.4-0.1c15.1,0.8,29.7,4.2,43.2,10c0.6-0.2,1.3-0.5,2-0.8 C373.1,85.7,321.7,82,285.2,107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A5D34",
    d: "M401.7,38.1c-2.6-0.6-5.5-0.7-8.7-0.2c-0.2-0.3-0.3-0.6-0.5-0.9c-1.1,10-3.8,26.1-11.7,37.4 c1,0.1,1.9,0.2,2.9,0.3C392.7,67.9,401.7,50.9,401.7,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A5D34",
    d: "M364.8,28.9c-3.1,1-6,2.5-8.7,4.7c-0.2,13.4-2.5,28.5-6.7,40.2c0.8,0,1.6-0.1,2.5-0.1 C362.2,62.4,365.4,40.9,364.8,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A5D34",
    d: "M327.9,76.7c1.2-0.3,2.4-0.5,3.7-0.7c-9.9-10.1-17.7-23-18.4-36.2c0,0.1,0,0.2,0,0.2 c-2.8-0.1-5.6,0.1-8.3,0.7C305.7,56.7,317,70.4,327.9,76.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC8D4F",
    d: "M414.4,47.7c-2.7-4.5-6.9-8.2-12.7-9.6c0,12.8-9,29.8-18,36.5c5.2,0.5,10.1,1.2,14.5,2.1 c2.9,0.5,5.4,1.1,7.7,1.8c2.3-1.9,5.4-5.8,6.7-7.3C416.7,66.1,418.8,55,414.4,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC8D4F",
    d: "M364.8,28.9c0.6,12.1-2.6,33.6-13,44.8c9.5-0.4,19.6-0.1,29,0.7c7.8-11.3,10.6-27.3,11.7-37.4 C387.8,29.6,375.7,25.5,364.8,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC8D4F",
    d: "M355.8,33.8c-8.3-12.4-40.9-8.7-42.8,6c0.8,13.1,8.6,26,18.4,36.2c0.4-0.1,0.9-0.2,1.3-0.2 c5-0.9,10.6-1.6,16.5-1.9c4.3-11.7,6.5-26.8,6.7-40.2C356,33.7,355.9,33.8,355.8,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC8D4F",
    d: "M304.7,40.7c-4.1,0.8-7.9,2.5-11.1,5.2c-7.6,6.5-9.9,14.7-8.1,23.6c1.8,9.2,5.8,12.5,12.9,17.6 c8.9-5.4,19.2-8.3,29.5-10.4C317,70.4,305.7,56.7,304.7,40.7z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ABFF7F",
    strokeWidth: 0.1108,
    d: "M443.4,193.7L443.4,193.7L443.4,193.7 C443.6,193.6,443.5,193.5,443.4,193.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M472.5,189.2c0-1.9,0-3.7-0.2-5.5l0,0C472.4,185.4,472.5,187.3,472.5,189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M434.8,124.1c-1-0.8-2-1.5-3-2.3C432.7,122.6,433.8,123.3,434.8,124.1L434.8,124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M428.7,119.7c0.9,0.6,1.8,1.3,2.7,1.9C430.5,120.9,429.6,120.3,428.7,119.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M472.5,189.2c0,0.1,0,0.3,0,0.4C472.5,189.4,472.5,189.3,472.5,189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M428.1,119.3c0.2,0.1,0.4,0.3,0.6,0.4C428.5,119.5,428.3,119.4,428.1,119.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M463.1,156.8c-7.1-12.7-16.8-23.7-28.3-32.7l0,0c-1-0.8-2-1.5-3-2.3c-0.1-0.1-0.2-0.2-0.3-0.2 c-0.9-0.6-1.8-1.3-2.7-1.9c-0.2-0.1-0.4-0.3-0.6-0.4c-6.3-4.2-13.1-7.9-20.1-10.9c-13.5-5.8-28.1-9.2-43.2-10 c-5.5-0.3-11-0.3-16.4,0.1c-5.5,0.4-10.9,1-16.2,2c-7.1,1.3-14.1,3.2-20.9,5.6s-13.5,5.5-19.9,9.2c-24.5,14.1-44.7,36.6-52.1,62.2 c-1.9,11.1-1.2,23,6.9,28.3c4.1,2.7,9.9,4.1,14.7,2.7c1.6-1.7,2.6-4,2.8-6.4c-4.6-20.6-5.8-44.8,10.9-61.1 c-14.5,20.8-8.8,46.7-6.5,59.8c8.5-0.5,12.7-9.6,13.3-18.5c-0.9-21.2,1.2-49.2,23.5-65.4c-17.1,18.2-22,40.8-19.5,63.1 c11.5,0.4,21.1-5.8,23.5-14.4l0.1,0.1c-2.6-18.7-1.4-42.5,15.1-56.7c-11.2,13.1-16.4,40-10.4,59.6c6.4,2,14.3-1.5,16.7-6.3 c0.1,0.1,0.2,0.2,0.3,0.3c-3-18.7,0.6-41.4,12-56.7c-5.3,12.4-13.1,29.6-8.6,58.5c4.4,1,10.3-0.9,13.2-3.4 c0.1,0.2,0.2,0.5,0.3,0.7c-1.8-19.4,1.7-40.5,14.5-55.8c-10,17.8-13.3,39.7-10,60.1c5.5,2.7,13.7,2.1,17.2-2.8 c6.3-18.4,7.1-38.8,3.1-57.3c8.1,16.9,5.7,40.7-0.1,59.2c4,3.3,10,4.2,14.9,2.6c7-18.7,6.8-42.9,2.8-57 c8.2,15.6,6.9,36.5,2.1,54.1c0,0,0,0,0.1-0.1c0.8,4.4,7.1,10.3,11.3,11.9c4.8,1.9,8.3,2,12.9,0.5c4.3-20.3-0.1-46.4-4.8-54.3 c12,13.9,11.7,37.4,8.7,52.8c0.1,0,0.1-0.1,0.2-0.1c0.3,10.7,9.5,19.2,17.7,19.3c8.4-20.1,2.9-45.7-3.6-60.7 c14.1,20.2,14.1,45.5,8.2,61.3c-1.8,10.8,7,15.1,11.7,15.6c0.6,0.1,1.2,0.1,1.8,0.1c8.5-0.3,13.7-8.9,15.2-14.9 c0.1-0.3,0.2-0.6,0.2-0.9c0.3-1.9,0.4-3.8,0.5-5.7c0-0.1,0-0.3,0-0.4c0-1.9-0.1-3.7-0.2-5.5l0,0c-1-9.5-4.6-18.5-9.3-26.8 L463.1,156.8L463.1,156.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9C7540",
    d: "M409.9,107.6c5.4-2.5,10.4-7.6,9.6-13.5c-0.4-2.8-1-5.1-2-7.1c-41.2-14.7-89.9-13.3-129,7.6 c-2.4,2.6-4,5.5-3.9,9.3c0,1.2,0.2,2.4,0.6,3.6C321.7,82,373.1,85.7,409.9,107.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C7540",
    d: "M245.7,211.1c-3.9-1.8-6.3-5.3-7.7-9.3c-12.2,3.1-15.9,19.6-3.5,26.3c-6.3,5.6-2.2,19.5,4.7,23.8 c4.2,2.8,4.3,3.2,6.6,4c2.7,0.9,5.1,0.7,7.6,0.3c5.9-1.1,8.4-7.9,8.8-11c0.5-4-2.3-10.1-6.7-10.9c6.9-5.7,6.4-17-0.8-22.2 C251.9,212.7,248.8,212.5,245.7,211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C7540",
    d: "M456.5,211.1c-6.5,6.1-7.4,18.4,4.8,22.3c-3.5,3.2-6.1,8.9-5.6,13.1c0.4,3.3,3.3,9.5,8.3,7.1 c4.9,5,8.9,0.5,11.7-1.8c8.8-8.3,18.3-29.3,6.2-35.5c9.3-6,3.3-17.5-10.2-20.2C470.2,202.2,465.1,210.9,456.5,211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C7540",
    d: "M487.5,190.1c-12.4-11.8-12.8-29.1-24.9-41.3c13.1,3.3,24.7,10.7,27.6,23.3c2.6-3.4-0.1-16.2-1.7-20.4 c-2.4-6.3-5.7-9.4-11.5-13.6c-7.4-5.3-16.3-7.4-25.1-9.4c-5.2-1.2-11.3-2.7-17.1-4.7c11.5,9,21.3,20,28.3,32.7H463 c4.6,8.4,8.3,17.3,9.3,26.8c4.8,4.7,12.8,6.4,18.5,8.6C489.4,191.7,488.5,191.1,487.5,190.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M431.4,121.6c0.1,0.1,0.2,0.2,0.3,0.2C431.6,121.7,431.5,121.7,431.4,121.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C200",
    d: "M443.4,193.7L443.4,193.7L443.4,193.7C443.6,193.6,443.5,193.5,443.4,193.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9BD78",
    d: "M246.1,205.7c-8.1-5.3-8.8-17.2-6.9-28.3c-1.4,4.7-2.3,9.5-2.7,14.4c0,3.3,0.4,6.7,1.5,9.9 c1.4,4,3.8,7.5,7.7,9.3c3.1,1.4,6.3,1.7,9,1c2.4-0.6,4.5-1.9,6.1-3.6C256,209.8,250.1,208.4,246.1,205.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BD78",
    d: "M263.6,202c0.1-0.6,0.1-1.2,0-1.8c1.6,0.4,3,0.6,4.4,0.5c-2.4-13.1-8.1-38.9,6.5-59.8 C257.8,157.2,259.1,181.4,263.6,202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BD78",
    d: "M434.8,134.1c6.5,15,12,40.6,3.6,60.7c1.8,0,3.5-0.3,5-1.1l0,0c0-0.1,0.1-0.1,0,0l0,0 c-0.2,0.6-0.3,1.2-0.4,1.7C448.9,179.6,448.9,154.3,434.8,134.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BD78",
    d: "M416.5,177c1.2-0.4,2.5-0.9,3.9-1.5c3-15.4,3.3-38.9-8.7-52.8C416.5,130.6,420.8,156.7,416.5,177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BD78",
    d: "M281.4,182.1c0.1-0.9,0.1-1.8,0.1-2.6c1.3,0.2,2.7,0.3,4,0.4c-2.5-22.4,2.3-44.9,19.5-63.1 C282.6,132.9,280.5,160.9,281.4,182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BD78",
    d: "M330.7,162.5c0.9,0.9,2.1,1.5,3.4,1.8c-4.5-28.9,3.2-46.2,8.6-58.5C331.4,121,327.7,143.8,330.7,162.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BD78",
    d: "M309,165.6c1.4,1.4,3,2.4,4.7,2.9c-6-19.6-0.8-46.5,10.4-59.6C307.6,123.1,306.4,146.9,309,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BD78",
    d: "M369.4,163c0.2-0.3,0.4-0.5,0.5-0.8c0.7,1,1.6,1.9,2.5,2.7c5.8-18.5,8.1-42.3,0.1-59.2 C376.6,124.2,375.8,144.7,369.4,163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BD78",
    d: "M387.4,167.5c1.8-0.6,3.5-1.6,4.9-2.9c4.8-17.6,6.1-38.5-2.1-54.1C394.2,124.6,394.4,148.8,387.4,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BD78",
    d: "M347.7,161.5c0.9,1.8,2.5,3.3,4.5,4.3c-3.4-20.3-0.1-42.2,10-60.1C349.4,121.1,345.9,142.1,347.7,161.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9BD78",
    d: "M472.2,183.6L472.2,183.6c-0.4-3.9-1.2-7.7-2.4-11.4c1.8,8.1,2.1,16.7-0.7,23.6 c-2.5,6.2-9.1,13.1-16.5,14.8c0.8,0.2,1.5,0.4,2.1,0.4c0.6,0.1,1.2,0.1,1.8,0.1c8.5-0.3,13.7-8.9,15.2-14.9 c0.1-0.3,0.2-0.6,0.2-0.9c0.3-1.9,0.4-3.8,0.5-5.7c0-0.1,0-0.3,0-0.4C472.5,187.3,472.4,185.4,472.2,183.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanHairstyle4C);
export default __webpack_public_path__ + "static/media/woman_hairstyle_4c.2c4bdff3d69e7408fd2baa5ef34ba8d7.svg";
export { ForwardRef as ReactComponent };